import { api } from '@/lib/api'

export type AnalyticsDashboard = {
  score_engajamento_medio: number | null
  score_geral_medio: number | null
  alertas_criticos: number
  turnover_mes?: {
    periodo_inicio?: string
    periodo_fim?: string
    headcount_inicio?: number
    headcount_fim?: number
    admitidos?: number
    demitidos?: number
    taxa_turnover?: number
    benchmark_mercado?: number
    status?: string
  }
  enps?: {
    eNPS?: number | null
    promotores?: number
    neutros?: number
    detratores?: number
  }
}

export type AnalyticsAlerta = {
  id: string
  titulo?: string
  tipo?: string
  tipo_display?: string
  prioridade?: string
  status?: string
  mensagem?: string
  descricao?: string
  created_at?: string
  [key: string]: unknown
}

export type ScoreSetor = {
  id?: string
  departamento_nome?: string
  departamento?: string
  score_geral?: number | string | null
  score_engajamento?: number | string | null
  headcount?: number
  [key: string]: unknown
}

export async function fetchAnalyticsDashboard() {
  const res = await api.get<{ sucesso?: boolean; dados: AnalyticsDashboard }>(
    '/analytics/dashboard/',
  )
  return res.dados
}

export async function fetchAnalyticsAlertas() {
  const res = await api.get<{
    sucesso?: boolean
    dados: AnalyticsAlerta[]
    nao_lidos?: number
  }>('/analytics/alertas/')
  return res
}

export async function fetchScoresSetores() {
  const res = await api.get<{ sucesso?: boolean; dados: ScoreSetor[] }>(
    '/analytics/scores/setores/',
  )
  return res.dados || []
}
